<template>
  <div>
    <!-- 顶部 -->
    <detailHeader />
    <div class="content">
      <!--通知公告  -->
      <h1>{{ $t("message.Announcements") }}</h1>

      <el-form :model="datas" :rules="rules" ref="datas" label-width="150px" class="demo-ruleForm">
        <!-- 发送时间 -->
        <el-form-item :label="$t('message.sendTime') + ':'" prop="datetime_start" placeholder="请选择">
          <el-date-picker v-model="datas.datetime_start" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择发送时间" />
        </el-form-item>
        <!-- 通告群体： -->
        <el-form-item :label="$t('message.noticeGroup') + ':'" prop="range">
          <el-select v-model="datas.range" placeholder="请选择" @change="changeNange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 人员选择 -->
        <el-form-item :label="$t('message.personnelSelection') + ':'"
          v-if="datas.range == 11 || datas.range == 21 || datas.range == 31">
          <div class="value">
            <div class="button">
              <!-- 选择 -->
              <el-button type="primary" class="primary" @click="choose">
                {{ $t("message.choose") }}
              </el-button>
            </div>
            <!-- 部分客户 -->
            <div class="table" v-if="datas.range == 11 || datas.range == 31">
              <el-table :data="selectedPersonnel" :default-sort="{ prop: 'date', order: 'descending' }"
                :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" max-height="400px">
                <el-table-column align="center" type="index" width="80" label="NO">
                </el-table-column>
                <!-- 客户ID -->
                <el-table-column align="center" :label="$t('message.clientID')" prop="id">
                </el-table-column>
                <!-- 客户名称 -->
                <el-table-column align="center" :label="$t('message.userName')" prop="realname">
                </el-table-column>
                <!-- 删除 -->
                <el-table-column :label="$t('message.delete')" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="delSelectedPersonnel(scope.row.id)">
                      {{ $t("message.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--部分人员 -->
            <div class="table" v-else-if="datas.range == 21">
              <el-table :data="selectedPersonnel" :default-sort="{ prop: 'date', order: 'descending' }"
                :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" max-height="400px">
                <!-- 登录账号 -->
                <el-table-column align="center" :label="$t('message.loginName')" prop="realname">
                </el-table-column>
                <!-- 用户名 -->
                <el-table-column align="center" :label="$t('message.UserName')" prop="username">
                </el-table-column>
                <!-- 删除 -->
                <el-table-column :label="$t('message.delete')" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="delSelectedPersonnel(scope.row.id)">
                      {{ $t("message.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

          </div>
        </el-form-item>
        <!-- 通知标题 -->
        <el-form-item :label="$t('message.noticeTitle') + ':'" prop="title">
          <el-input v-model="datas.title" type="textarea"></el-input>
        </el-form-item>
        <!-- 通知内容 -->
        <el-form-item :label="$t('message.noticeContent') + ':'" prop="content">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="datas.content" :options="quillOption"
            @change="onEditorChange($event)">
          </quill-editor>
        </el-form-item>
      </el-form>
      <!-- 预览 -->
      <div class="btn">
        <!-- 保存 -->
        <el-button type="primary" @click="preview">
          {{ $t("message.save") }}
        </el-button>
        <!--取 消  -->
        <el-button type="primary" class="dark">
          {{ $t("message.cancel") }}
        </el-button>
      </div>
    </div>
    <!-- 人员选择 -->
    <el-dialog :title="$t('message.personnelSelection')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="800px" center>
      <div class="body">
        <div class="search">
          <!-- 客户ID： -->
          <div class="label" v-if="datas.range == 11">
            {{ $t("message.clientID") }}:
          </div>
          <!-- 后台管理人员账号： -->
          <div class="label" v-else-if="datas.range == 21">
            {{ $t("message.accountOfBackgroundAdministrator") }}:
          </div>
          <!-- 部分客户-SASS -->
          <div class="label" v-else-if="datas.range == 31">
            SASS-ID:
          </div>
          <!--搜索  -->
          <div class="value" v-if="datas.range == 31">
            <el-select v-model="personnelData.appKey" placeholder="请选择" @change="sassPlatformUsers" style="width:180px">
              <el-option v-for="item in sassPlatformList" :key="item.appKey" :label="item.name" :value="item.appKey">
              </el-option>
            </el-select>
          </div>
          <!--  客户ID： -->
          <div class="label" v-if="datas.range == 31">
            {{ $t("message.clientID") }}:
          </div>
          <!--搜索  -->
          <div class="value">
            <el-input v-model="personnelData.searchText" onfocus="this.select()"></el-input>
          </div>
          <!-- 查询 -->
          <div class="label" style="width: 60px;">
            <el-button type="primary" @click="getAccountInfo">
              {{ $t("message.inquire") }}
            </el-button>
          </div>
        </div>
        <el-table :data="userData" border :header-cell-style="{ background: '#EDEFF4' }" max-height="500px">
          <!-- 客户ID -->
          <el-table-column prop="id" :label="$t('message.clientID')" align="center"
            v-if="datas.range == 11 || datas.range == 31">
          </el-table-column>
          <!--客户名称-->
          <el-table-column prop="realname" :label="$t('message.customerName')" align="center"
            v-if="datas.range == 11 || datas.range == 31">
          </el-table-column>
          <!--登录账号  -->
          <el-table-column prop="username" :label="$t('message.loginName')" align="center" v-if="datas.range == 21">
          </el-table-column>
          <!--用户名  -->
          <el-table-column prop="realname" :label="$t('message.UserName')" align="center" v-if="datas.range == 21">
          </el-table-column>
          <!-- 删除 -->
          <el-table-column align="center">
            <template slot-scope="scope">

              <el-button size="mini" type="danger" @click="delItem(scope.row.id)">
                {{ $t("message.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 预览 -->
    <preview :datas="datas" ref="preview" />
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import preview from "./preview";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    detailHeader,
    quillEditor,
    preview,
  },
  data() {
    return {
      datas: {
        title: "",
        content: "",
        range: "", //10-全部客户,11-部分客户,20-全部管理员,21-部分管理员
        ids: [],
        datetime_start: "",
        datetime_end: "",
      },
      rules: {
        title: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        range: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        datetime_start: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
      options: [
        {
          label: "全部客户-代购",
          value: "10",
        },
        {
          label: "部分客户-代购",
          value: "11",
        },
        {
          label: "全部管理员",
          value: "20",
        },
        {
          label: "部分管理员",
          value: "21",
        },
        {
          label: "全部客户-SASS",
          value: "30",
        },
        {
          label: "部分客户-SASS",
          value: "31",
        },
      ],
      quillOption: quillConfig,
      //   人员选择
      dialogVisible: false,
      selectedPersonnel: [],
      personnelData: {
        searchText: "",
        type: "",
      },
      userData: [],
      sassPlatformList: [],//sass平台列表

    };
  },
  methods: {
    onEditorChange(e) {
      console.log(e);
    },
    //状态筛选
    changeNange(e) {
      if (e == 11) {
        this.personnelData.type = "user";
      } else if (e == 21) {
        this.personnelData.type = "admin";
      } else if (e == 31) {
        this.personnelData.type = "user_sass";
        this.$api.noticeApi
          .sassPlatformList()
          .then((res) => {

            this.sassPlatformList = res.data
          });
      }
      this.userData = [];
      this.selectedPersonnel = [];
    },
    // 选择
    choose() {
      this.userData = [];
      this.personnelData.searchText = "";
      this.dialogVisible = true;
    },
    //人员搜索
    getAccountInfo() {
      this.$api.siteConfiguration
        .getAccountInfo(this.personnelData)
        .then((res) => {
          if (res.data == false) {
            return this.$message.error("未匹配此ID");
          }
          this.userData = [... this.userData, ...res.data.batch]
          var hash = {};
          this.userData = this.userData.reduce(function (item, next) {
            hash[next.id]
              ? ""
              : (hash[next.id] = true && item.push(next));

            return item;
          }, []);
        });
    },
    // 删除未选择人员
    delItem(id) {
      let index = this.userData.findIndex((item) => item.id == id);
      this.userData.splice(index, 1);
    },
    //删除已选择的
    delSelectedPersonnel(id) {
      let index = this.selectedPersonnel.findIndex((item) => item.id == id);
      this.selectedPersonnel.splice(index, 1);
    },
    //人员保存
    save() {
      this.selectedPersonnel = [...this.selectedPersonnel, ...this.userData];
      this.dialogVisible = false;
    },
    //预览
    preview() {
      this.$refs.datas.validate((valid) => {
        if (valid) {
          this.datas.ids = []
          this.selectedPersonnel.forEach(item => {
            this.datas.ids.push(item.id)
          })
          this.$refs.preview.dialogVisible = true;
        }
      });
    },
    //SASS平台全部客户列表
    sassPlatformUsers(e) {
      this.$api.noticeApi
        .sassPlatformUsers({ appKey: e })
        .then((res) => {
          this.userData = [...this.userData, ...res.data]
          console.log(res);

        });
    },

  },
};
</script>
<style lang='scss' scoped>
h1 {
  font-size: 25px;
  font-weight: 600;
  margin: 0 0 40px;
  text-align: center;
}

.content {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin: 24px;
  min-width: 1814px;

  .value {
    flex: 1;
    display: flex;

    .button {
      width: 100px;
      margin-right: 40px;
    }

    .table {
      width: 500px;
    }
  }

  /deep/.el-form-item__label {
    font-size: 20px;
  }

  /deep/.el-textarea__inner {
    height: 100px;
  }
}

/deep/.ql-editor {
  min-height: 300px !important;
}

.search {
  display: flex;
  margin-bottom: 20px;
  line-height: 40px;

  .label {
    width: 120px;
    text-align: right;
  }

  .value {
    flex: 1;
    margin: 0 30px;
  }
}

.btn {
  text-align: center;
}
</style>